import { EGDSSpacing } from '@egds/react-core/spacing';
import { inject, observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
import { updateSearch } from 'bernie-core';
import { useLocalization } from '@shared-ui/localization-context';
import { InfositeQueryAdapter } from 'stores/adapters/infosite-query-adapter';
import { singleUseQueryParams } from 'stores/models';
import { SearchQueryAdapter } from 'stores/adapters/search-query-adapter';
import { multiItemCompleteSearchCriteria } from 'components/multi-item/utils';
import { parse } from 'query-string';
import { SearchWizardComposer } from './search-wizard-composer';
export const SingleOfferSearchForm = props => React.createElement(WrappedSingleOffer, Object.assign({}, props));
SingleOfferSearchForm.displayName = 'SingleOfferSearchForm';
export const WrappedSingleOffer = inject('currentHotel', 'context')(observer(({
  currentHotel,
  context
}) => {
  const l10n = useLocalization();
  const history = useHistory();
  const location = useLocation();
  const navigateTo = submitUrl => {
    history.push(submitUrl);
  };
  const onUpdateResults = searchCriteria => {
    handleUpdateResults({
      context,
      criteria: searchCriteria.toJSON(multiItemCompleteSearchCriteria),
      history,
      location,
      l10n
    });
  };
  React.useEffect(() => {
    const searchCriteria = currentHotel || undefined;
    const {
      startDate,
      endDate,
      adults,
      children
    } = SearchQueryAdapter.parseOut(searchCriteria);
    // 0 - children from search is undefined
    const childrenFormatted = typeof children === 'undefined' ? '' : children;
    currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.setOfferData({
      startDate,
      endDate,
      adults,
      children: childrenFormatted
    });
  }, [currentHotel]);
  const searchWizardComposerProps = {
    navigateTo,
    onUpdateResults
  };
  return React.createElement(ErrorBoundary, {
    label: "hotel.information.searchform.singleoffer"
  }, React.createElement(EGDSSpacing, {
    padding: {
      inline: 'three'
    }
  }, React.createElement("div", null, React.createElement(SearchWizardComposer, Object.assign({}, searchWizardComposerProps)))));
}));
export const handleUpdateResults = ({
  context,
  criteria,
  history,
  location,
  l10n
}) => {
  const params = Object.assign(Object.assign({}, criteria), {
    localDateFormat: context === null || context === void 0 ? void 0 : context.localDateFormat
  });
  const paramsFilter = key => !key.startsWith('pwaDialog') && !key.startsWith('rm') && !singleUseQueryParams.includes(key);
  const newParams = InfositeQueryAdapter.parseOut(params, l10n);
  const hasOpenDialog = Boolean(parse(location.search).pwaDialog);
  if (hasOpenDialog) {
    // HACK: we used to listen for window popstate event before making the call to updateSearch to update url params
    // but bernie no longer calls history.goBack() when a dialog closes so the event is never fired. Until we can come
    // up with another bernie fix for the race condition that occurs between this updateSearch call and the same call in
    // bernie dialog-context - we'll have to use the setTimeout here
    setTimeout(() => updateSearch({
      history,
      location,
      newParams,
      replace: true,
      paramsFilter
    }), 50);
  } else {
    updateSearch({
      history,
      location,
      newParams,
      replace: true,
      paramsFilter
    });
  }
};